<template>
  <div>
    <section v-if="selectedCompany.financeData.length && computedAvailableYears >= 2">
      <h1 class="text-left mt-5 mb-3">Üzemi eredmények</h1>
      <div class="CompanyBarChart mt-5" style="max-width: 770px;position: relative; margin: 0 auto;">
        <line-chart :chartdata="computedLineChartData" :options="computedLineChartData.options" />
      </div>
    </section>
    <section v-if="selectedCompany.financeData.length && computedAvailableYears == 1">
      <h1 class="text-left mt-5 mb-3">Üzemi eredmények</h1>
      <div class="CompanyBarChart mt-5" style="max-width: 700px;position: relative; margin: 0 auto;">
        <line-chart :chartdata="lastYearBarChart" :options="lastYearBarChart.options" />
      </div>
    </section>
  </div>
</template>

<script>
import LineChart from '@/components/LineChart.vue'
export default {
  props: {
    selectedCompany: { type: Object, required: true }
  },
  components: {
    LineChart
  },
  computed: {
    lastYearRevenue() {
      if (this.selectedCompany.financeData.length) {
        const revenue = this.selectedCompany.financeData.find(financeItem => financeItem.name === 'Árbevétel')

        const lastYearRevenue = revenue.data[revenue.data.length - 1]
        const result = {
          value: lastYearRevenue.value * lastYearRevenue.multiplier,
          currency: lastYearRevenue.currency
        }
        return result
      }
      return ''
    },
    lastYearResult() {
      if (this.selectedCompany.financeData.length) {
        const revenue = this.selectedCompany.financeData.find(
          financeItem => financeItem.name === 'Üzemi/üzleti eredmény'
        )

        const lastYearRevenue = revenue.data[revenue.data.length - 1]
        const result = {
          value: lastYearRevenue.value * lastYearRevenue.multiplier,
          currency: lastYearRevenue.currency
        }
        return result
      }
      return ''
    },
    lastYearBeforeTaxes() {
      if (this.selectedCompany.financeData.length) {
        const revenue = this.selectedCompany.financeData.find(
          financeItem => financeItem.name === 'Adózás előtti eredmény'
        )

        const lastYearRevenue = revenue.data[revenue.data.length - 1]
        const result = {
          value: lastYearRevenue.value * lastYearRevenue.multiplier,
          currency: lastYearRevenue.currency
        }
        return result
      }
      return ''
    },
    currenciesForRadialSeriesBar() {
      return [this.lastYearRevenue.currency, this.lastYearResult.currency, this.lastYearBeforeTaxes.currency]
    },

    computedLabel() {
      if (this.selectedCompany.financeData.length) {
        const operatingProfit = this.selectedCompany.financeData.find(
          financeItem => financeItem.name === 'Üzemi/üzleti eredmény'
        )
        const cChartLabels = operatingProfit.data.map(dataItem => dataItem.year)
        return cChartLabels
      }
      return []
    },
    computedChartData() {
      if (this.selectedCompany.financeData.length) {
        const operatingProfit = this.selectedCompany.financeData.find(
          financeItem => financeItem.name === 'Üzemi/üzleti eredmény'
        )

        const cChartData = operatingProfit.data.map(dataItem => dataItem.value * dataItem.multiplier)
        return cChartData
      }
      return []
    },
    computedChartDataArbevetel() {
      if (this.selectedCompany.financeData.length) {
        const operatingProfit = this.selectedCompany.financeData.find(financeItem => financeItem.name === 'Árbevétel')

        const cChartData = operatingProfit.data.map(dataItem => dataItem.value * dataItem.multiplier)
        return cChartData
      }
      return []
    },

    computedBeforeTaxes() {
      if (this.selectedCompany.financeData.length) {
        const beforeTaxes = this.selectedCompany.financeData.find(
          financeItem => financeItem.name === 'Adózás előtti eredmény'
        )

        const cChartData = beforeTaxes.data.map(dataItem => dataItem.value * dataItem.multiplier)
        return cChartData
      }
      return []
    },
    computedAvailableYears() {
      if (this.selectedCompany.financeData.length) {
        const income = this.selectedCompany.financeData.find(financeItem => financeItem.name === 'Árbevétel')
        const cIncome = income.data.map(v => {
          return v
        })
        return cIncome.length
      }
      return 0
    },
    computedCurrency() {
      if (this.selectedCompany.financeData.length) {
        const operatingProfit = this.selectedCompany.financeData.find(
          financeItem => financeItem.name === 'Üzemi/üzleti eredmény'
        )
        return operatingProfit.data.length ? operatingProfit.data[0].currency : 'HUF'
      }
      return 'HUF'
    },
    lastYearBarChart() {
      const chartDataLine = {
        type: 'bar',
        labels: [''],
        datasets: [
          {
            label: 'Árbevétel',
            data: [this.lastYearRevenue.value],
            borderColor: '#BA3B46',
            pointBackgroundColor: 'white',
            borderWidth: 0,
            pointBorderColor: '#BA3B46',
            backgroundColor: '#BA3B46',
            yAxisID: 'B',
            barPercentage: 0.5
          },
          {
            label: 'Adózás előtti eredmény',
            data: [this.lastYearBeforeTaxes.value],
            borderColor: 'rgba(4, 132, 187, 0.6)',
            pointBackgroundColor: 'white',
            borderWidth: 0,
            pointBorderColor: 'rgba(4, 132, 187, 0.6)',
            backgroundColor: 'rgba(4, 132, 187, 0.6)',
            yAxisID: 'B',
            barPercentage: 0.5
          },
          {
            label: 'Üzemi/üzleti eredmény',
            data: [this.lastYearResult.value],
            borderColor: '#00a03c',
            pointBackgroundColor: 'white',
            borderWidth: 0,
            pointBorderColor: '#00b03c',
            backgroundColor: 'rgba(0, 144, 60, 0.6)',
            yAxisID: 'B',
            barPercentage: 0.5
          }
        ],
        options: {
          tooltips: {
            callbacks: {
              label: function(tooltipItem) {
                return tooltipItem.yLabel
                  .toString()
                  .split(/(?=(?:...)*$)/)
                  .join(' ')
              }
            }
          },
          scales: {
            yAxes: [
              {
                id: 'B',
                type: 'linear',
                position: 'left',
                scaleLabel: {
                  display: true,
                  labelString: 'Üzemi/Üzleti és Adózás előtti eredmény'
                },
                gridLines: {
                  display: true
                },
                ticks: {
                  beginAtZero: true,
                  callback: value => {
                    return this.abbreviateNum(value)
                  }
                }
              }
            ],
            xAxes: [
              {
                gridLines: {
                  display: false
                }
              }
            ]
          },
          legend: {
            display: true
          },
          responsive: true,
          maintainAspectRatio: true
        }
      }
      return chartDataLine
    },
    computedLineChartData() {
      const chartDataLine = {
        type: 'bar',
        labels: this.computedLabel,
        datasets: [
          {
            label: 'Árbevétel',
            data: this.computedChartDataArbevetel,
            borderColor: '#BA3B46',
            pointBackgroundColor: '#BA3B46',
            borderWidth: 2,
            pointBorderColor: '#BA3B46',
            backgroundColor: '#BA3B46',
            fill: 'transparent',
            type: 'line',
            yAxisID: 'B'
          },
          {
            label: 'Üzemi/üzleti eredmény',
            data: this.computedChartData,
            borderColor: '#00a03c',
            pointBackgroundColor: 'white',
            borderWidth: 1,
            pointBorderColor: '#00b03c',
            backgroundColor: 'rgba(0, 144, 60, 0.6)',
            type: 'bar',
            yAxisID: 'A',
            borderSkipped: false
          },
          {
            label: 'Adózás előtti eredmény',
            data: this.computedBeforeTaxes,
            borderColor: 'rgba(4, 132, 187, 0.6)',
            pointBackgroundColor: 'white',
            borderWidth: 1,
            pointBorderColor: 'rgba(4, 132, 187, 0.6)',
            backgroundColor: 'rgba(4, 132, 187, 0.6)',
            type: 'bar',
            yAxisID: 'A'
          }
        ],
        options: {
          tooltips: {
            callbacks: {
              label: function(tooltipItem) {
                return tooltipItem.yLabel
                  .toString()
                  .split(/(?=(?:...)*$)/)
                  .join(' ')
              }
            }
          },
          scales: {
            yAxes: [
              {
                id: 'A',
                type: 'linear',
                position: 'right',
                scaleLabel: {
                  display: true,
                  labelString: 'Üzemi/Üzleti és Adózás előtti eredmény'
                },
                ticks: {
                  beginAtZero: true,
                  callback: value => {
                    return this.abbreviateNum(value)
                  }
                },
                gridLines: {
                  display: false
                }
              },
              {
                id: 'B',
                type: 'linear',
                position: 'left',
                scaleLabel: {
                  display: true,
                  labelString: 'Árbevétel'
                },
                gridLines: {
                  display: true
                },
                ticks: {
                  beginAtZero: true,
                  callback: value => {
                    return this.abbreviateNum(value)
                  }
                }
              }
            ],
            xAxes: [
              {
                gridLines: {
                  display: false
                }
              }
            ]
          },
          legend: {
            display: true
          },
          responsive: true,
          maintainAspectRatio: true
        }
      }
      return chartDataLine
    }
  },
  methods: {
    abbreviateNum(num) {
      if (num > 999 && num < 1000000) {
        return (num / 1000).toFixed(0) + 'e'
      } else if (num > 1000000 && num < 1000000000) {
        return (num / 1000000).toFixed(0) + 'M'
      } else if (num > 1000000000) {
        return (num / 1000000000).toFixed(0) + 'Mrd'
      } else if (num < 900 && num > -999) {
        return num
      } else if (num < -999 && num > -1000000) {
        return (num / 1000).toFixed(0) + 'e'
      } else if (num < -1000000 && num > -1000000000) {
        return (num / 1000000).toFixed(0) + 'M'
      } else if (num < -1000000000) {
        return (num / 1000000000).toFixed(0) + 'Mrd'
      }
    }
  }
}
</script>

<style scoped>
.CompanyBarChart {
  background-color: white;
  padding: 20px;
  border: 1px solid var(--color-gray-02);
  border-radius: 10px;
}

button {
  width: 250px;
  height: 48px;
  font-weight: bold;
}
</style>
